import { useContext } from 'react';
import { ProductsStateContext } from '../contexts/ProductsContext';

/**
 * Returns the list of Increase's products,
 */
export function useProductsState() {
  return useContext(ProductsStateContext);
}
